module.exports = __webpack_public_path__ + "public/img/handshake.4570f2ca.png";